var map = {
	"./bg-BG.json": 2158,
	"./data.json": 2159,
	"./de-DE.json": 2160,
	"./en-US.json": 2161,
	"./es-ES.json": 2162,
	"./es-LA.json": 2163,
	"./es-US.json": 2164,
	"./fr-CA.json": 2165,
	"./fr-FR.json": 2166,
	"./id-ID.json": 2167,
	"./it-IT.json": 2168,
	"./ja-JP.json": 2169,
	"./ko-KR.json": 2170,
	"./pl-PL.json": 2171,
	"./pt-BR.json": 2172,
	"./pt-PT.json": 2173,
	"./ru-RU.json": 2174,
	"./sv-SE.json": 2175,
	"./th-TH.json": 2176,
	"./zh-CN.json": 2177
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1323;